import loadable from '@loadable/component'

export const BannerLoadable = loadable(
  async () => (await import('./Banner')).Banner
)
